'use es6';

import { Record, Map as ImmutableMap, List } from 'immutable';
import { EntityTypes } from 'AdsUI/lib/Constants'; // The backend's entity types don't quite match.

export const ENTITY_TYPE_CONVERSION_MAP = {
  [EntityTypes.AD_SEQ_CAMPAIGNS_ATTRACT_STAGE]: 'AD_SEQ_CAMPAIGNS_ATTRACT_STAGE',
  [EntityTypes.AD_SEQ_CAMPAIGNS_CONVERT_STAGE]: 'AD_SEQ_CAMPAIGNS_CONVERT_STAGE',
  [EntityTypes.AD_SEQ_CAMPAIGNS_CLOSE_STAGE]: 'AD_SEQ_CAMPAIGNS_CLOSE_STAGE',
  [EntityTypes.CAMPAIGN]: 'CAMPAIGNS',
  [EntityTypes.ADGROUP]: 'ADGROUPS',
  [EntityTypes.AD]: 'ADS',
  [EntityTypes.KEYWORD]: 'KEYWORDS'
};
const ColumnDataInfoRecord = Record({
  allowed: null,
  selected: null
});
export const ColumnDataRecord = Record({
  allowed: ImmutableMap(),
  selected: ImmutableMap(),
  displayStrings: ImmutableMap(),

  getColumns(network, entityType) {
    const allowed = this.allowed.getIn([network, ENTITY_TYPE_CONVERSION_MAP[entityType]], List());
    return ColumnDataInfoRecord({
      allowed,
      selected: this.selected.getIn([network, ENTITY_TYPE_CONVERSION_MAP[entityType]], List()).filter(column => allowed.includes(column))
    });
  }

});